module.exports = new __parcel__URL__("discovery_prompt_has_interests.bd395f15.svg").toString();